interface EnvironmentConfig {
  api: {
    baseUrl: string;
  };
  app: {
    mapConstantId: number;
    mapboxToken: string;
    posthogKey?: string;
    muiLicenseKey?: string;
    posthogHost?: string;
    email?: string;
  };
  development: {
    isDev: boolean;
    isProduction: boolean;
  };
}

const parseNumber = (value: string | undefined, varName: string): number => {
  if (!value) {
    throw new TypeError(
      `Environment variable ${varName} is required but not set`
    );
  }

  const parsed = Number.parseInt(value, 10);
  if (Number.isNaN(parsed)) {
    throw new TypeError(
      `Environment variable ${varName} must be a valid number, got: ${value}`
    );
  }

  return parsed;
};

const parseString = (value: string | undefined, varName: string): string => {
  if (!value) {
    throw new TypeError(
      `Environment variable ${varName} is required but not set`
    );
  }

  return value.trim();
};

const parseOptionalString = (value: string | undefined): string | undefined => {
  return value?.trim() || undefined;
};

export const env: EnvironmentConfig = {
  api: {
    baseUrl: parseString(process.env.REACT_APP_API, "REACT_APP_API"),
  },
  app: {
    mapConstantId: parseNumber(
      process.env.REACT_APP_CONSTANT_ID_MAP,
      "REACT_APP_CONSTANT_ID_MAP"
    ),
    mapboxToken: parseString(
      process.env.REACT_APP_MAPBOX_TOKEN,
      "REACT_APP_MAPBOX_TOKEN"
    ),
    posthogKey: parseOptionalString(process.env.REACT_APP_POSTHOG_KEY),
    muiLicenseKey: parseOptionalString(process.env.REACT_APP_KEY_UI),
    posthogHost: parseOptionalString(process.env.REACT_APP_PUBLIC_POSTHOG),
    email: parseOptionalString(process.env.REACT_APP_EMAIL),
  },
  development: {
    isDev: process.env.NODE_ENV === "development",
    isProduction: process.env.NODE_ENV === "production",
  },
};

export const validateEnvironment = (): void => {
  try {
    // Validation is performed during env object initialization
    // If we reach this point, all required environment variables are valid
  } catch (error) {
    throw error;
  }
};

export default env;
